import React, { Component } from 'react';
import TextField from 'material-ui/TextField';
import FlatButton from 'material-ui/FlatButton';
import { HeadlineH1 } from './text/Headlines';
import ActionButtonRow from '../components/ActionButtonRow';
import { Centered500 } from './container/CenteredContainer';
import styled from 'styled-components';

const Success = styled.div`
  margin-bottom: 30px;
`;

export default class extends Component {
  state = { password: '', repeatPassword: '', changed: false };

  render() {
    let { password, repeatPassword, changed } = this.state;
    return (
      <Centered500>
        <HeadlineH1>Passwort ändern</HeadlineH1>
        {changed
          ? <Success>
              Dein Passwort wurde erfolgreich geändert.
              <br />
              Du kannst dich nun wieder in der Fenster App anmelden.
            </Success>
          : <div>
              Hier kannst du dein Passwort für Fenster ändern.<br />
              Anschließend kannst du dich wieder in der App anmelden.
              <TextField
                type="password"
                fullWidth={true}
                floatingLabelText="Passwort"
                value={password}
                autoFocus
                onChange={({ target: { value } }) =>
                  this.setState({ password: value })}
              />
              <TextField
                type="password"
                fullWidth={true}
                floatingLabelText="Passwort wiederholen"
                value={repeatPassword}
                onChange={({ target: { value } }) =>
                  this.setState({ repeatPassword: value })}
              />
              <ActionButtonRow>
                <div />
                <FlatButton
                  primary
                  onClick={() =>
                    this.props
                      .changePassword(password)
                      .then(() => this.setState({ changed: true }))}
                  label="Passwort ändern"
                  disabled={
                    !(password.length || repeatPassword.length) ||
                      password !== repeatPassword
                  }
                />
              </ActionButtonRow>
            </div>}
      </Centered500>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/ChangePassword.js